import { Globe2, MapPin } from "lucide-react";
import { REGIONS_INTL, REGIONS_INDIA } from "@/lib/site";

function Row({ items, icon: Icon, direction = "left", labelClass = "" }) {
  const dup = [...items, ...items, ...items];
  const animClass = direction === "left" ? "marquee-track" : "marquee-track-reverse";
  return (
    <div className="group relative overflow-hidden">
      {/* Soft edge fades */}
      <div className="absolute inset-y-0 left-0 w-24 md:w-40 bg-gradient-to-r from-charcoal to-transparent z-10 pointer-events-none" />
      <div className="absolute inset-y-0 right-0 w-24 md:w-40 bg-gradient-to-l from-charcoal to-transparent z-10 pointer-events-none" />

      <div className={`flex whitespace-nowrap py-5 md:py-6 ${animClass} group-hover:[animation-play-state:paused]`}>
        {dup.map((label, i) => (
          <div key={i} className="flex items-center gap-5 md:gap-7 px-5 md:px-7 shrink-0">
            <span className={`flex items-center gap-2.5 font-display text-[13px] md:text-sm tracking-[0.18em] uppercase transition-colors duration-300 hover:text-stenzia-gold ${labelClass}`}>
              <Icon size={14} className="text-stenzia-gold opacity-80" strokeWidth={1.6} />
              {label}
            </span>
            <span className="w-1 h-1 rounded-full bg-stenzia-gold/70 shrink-0" />
          </div>
        ))}
      </div>
    </div>
  );
}

export default function Marquee() {
  return (
    <section data-testid="marquee-section" className="relative bg-charcoal text-white border-y border-white/10 overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_rgba(201,162,39,0.06),_transparent_60%)] pointer-events-none" />
      <div className="relative">
        {/* INTERNATIONAL row label */}
        <div className="px-6 md:px-12 pt-6 md:pt-7 flex items-center gap-3 text-[10px] tracking-[0.4em] uppercase text-white/45 font-medium">
          <span className="kbd-line opacity-50" />
          International Markets
        </div>
        <Row items={REGIONS_INTL} icon={Globe2} direction="left" labelClass="text-white/85" />

        {/* divider */}
        <div className="mx-6 md:mx-12 h-px bg-gradient-to-r from-transparent via-stenzia-gold/25 to-transparent" />

        {/* INDIA row label */}
        <div className="px-6 md:px-12 pt-5 md:pt-6 flex items-center gap-3 text-[10px] tracking-[0.4em] uppercase text-stenzia-gold/85 font-medium">
          <span className="kbd-line opacity-50" />
          Indian Presence
        </div>
        <Row items={REGIONS_INDIA} icon={MapPin} direction="right" labelClass="text-white/70" />
        <div className="h-3" />
      </div>
    </section>
  );
}
